import { observer } from 'mobx-react-lite'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import SyncOutlined from '@mui/icons-material/SyncOutlined'
import { themeConfig } from '@gap/shared/theme'

export type ClientSyncState = 'idle' | 'syncing' | 'first-sync'

interface ClientSyncActionProps {
   state: ClientSyncState
   onSyncNow: () => void
}

/** The Clients row's trailing control: a Sync now button, or the label of the sync that is running. */
export default observer(function ClientSyncAction(props: ClientSyncActionProps) {
   if (props.state === 'idle') {
      return <Button variant="text" size="small" startIcon={<SyncOutlined />} onClick={props.onSyncNow}>Sync now</Button>
   }
   return <Stack direction="row" alignItems="center" spacing={1}>
      <CircularProgress size={16} />
      <Typography variant="caption" sx={{ color: themeConfig.primary[600] }}>
         {props.state === 'first-sync' ? 'First sync in progress' : 'Syncing clients'}
      </Typography>
   </Stack>
})
